import { main } from 'boot'
import { TYPE }  from 'network/network_api';
import SETTINGS from 'settings'
import minigame_client from 'minigame_client/minigame_client'
import { MinigameMathCommon } from "src/library/minigame_client/common/MinigameMathCommon"
import game from 'src/game'
import { get_prop } from 'utils'

SETTINGS.preserve_resource_format_for_all = true;

// hide ui panel
SETTINGS.ui_config = {};

SETTINGS.no_default_lib = true;

// entry point
main({
    //открыли страницу с игрой:
    on_space : s => minigame_client( s, MinigameMathCommon, 120 ),
    //игра загрузилась: эта функция будет вызываться многократно и game_space каждый раз будет чистеньким новым:
    reactive : ( game_space, c, app ) => {
        const container = app.gameContainer

        game_space.s( 'account_selection_changed' ).log()

        game_space.s( 'net' )
            .filter( data => data )
            .log()

        game_space.s( 'balance_poll' )
            .filter( p => p )
            .log()
        
        game_space.s( 'net' )
            .map( net => get_prop( net, [ 'bet' ] ) )
            .filter( bet => bet )
            .to( game_space.s( 'bet' ) )
        
        game( game_space, container )
    },
    screen_config : {
        resolution: { width : 800, height : 600 },
        loadscreen : {
            image : 'res/load_screen/mainfon.png',
            loadbar : {
                position : { x : 179, y : 536 },
                image : 'res/load_screen/loadbar.png',
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/main.es6